import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(23 * 3600 + 57 * 60 + 20);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'h'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-brand text-white" data-id="element-33" data-mp="ant4zreqjdrd">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] sm:text-xs" data-id="element-34" data-mp="6nisrx0cnr42">
        <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="13cphk2dq4mdy" />
        <span data-id="element-36" data-mp="18ddh5cg0qbjs">L&apos;offre de lancement se termine dans :</span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-37" data-mp="udc6x6dv5rrn">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-38" data-mp="yee99w32ujxu" data-mpi={index}>
              <span className="text-sm font-extrabold sm:text-base" data-id="element-39" data-mp="1m4ibbz0mabmq">
                {pad(unit.value)}
              </span>
              <span className="text-[9px] tracking-normal opacity-90" data-id="element-40" data-mp="1r44mm2wvxhsw">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="px-0.5 opacity-70" data-id="element-41" data-mp="1dadnzpkoziby">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}